import { SEMRushWebsiteTrafficModel } from '@mm/state/model/SEMRushWebsiteTrafficModel';
import classNames from 'classnames';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { PrimaryButton } from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import { AVERAGE_WEB_TRAFFIC_GROWTH } from '../WebsiteReportSummary/constants';
import styles from './MissedLeadsTimer.module.css';

const SECONDS_PER_MONTH = 2592000;
const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_MINUTE = 60;

export const MissedLeadsTimer = ({
  totalTraffic,
  onClick,
  buttonName = 'Activate Customers.ai Now!',
  withTooltip,
  css,
}: {
  totalTraffic: SEMRushWebsiteTrafficModel;
  onClick: () => void;
  buttonName?: string;
  withTooltip?: boolean;
  css?: {
    button?: string;
    tooltip?: string;
  };
}) => {
  const organicLeads = totalTraffic?.trafficType?.organic || 0;
  const paidLeads = totalTraffic?.trafficType?.paid || 0;

  const leadsPerSecond =
    ((organicLeads + paidLeads) * AVERAGE_WEB_TRAFFIC_GROWTH) /
    SECONDS_PER_MONTH;
  const [lostLeadsByTime, setLostLeadsByTime] = useState(leadsPerSecond);
  const lostLeadsLocalized = lostLeadsByTime.toLocaleString('en-US', {
    minimumFractionDigits: 3,
  });
  const [secondsSinceMount, setSecondsSinceMount] = useState(
    moment().seconds(),
  );

  const time =
    secondsSinceMount < SECONDS_PER_MINUTE
      ? secondsSinceMount
      : secondsSinceMount > SECONDS_PER_HOUR
      ? Math.ceil(secondsSinceMount / SECONDS_PER_HOUR)
      : Math.ceil(secondsSinceMount / SECONDS_PER_MINUTE);
  const timeLabel =
    secondsSinceMount < SECONDS_PER_MINUTE
      ? 'seconds'
      : secondsSinceMount > SECONDS_PER_HOUR
      ? 'hours'
      : 'minutes';

  useEffect(() => {
    const interval = setInterval(() => {
      setLostLeadsByTime(prev => prev + leadsPerSecond);
      setSecondsSinceMount(prev => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [organicLeads]);

  return (
    <div className={styles.container}>
      <div
        className={classNames(styles.timerBlock, {
          [styles.widthAuto]: withTooltip,
        })}
      >
        <div className={styles.subheading}>Lost Leads This Month</div>
        <div className={styles.lostLeadsCount}>
          <div className={styles.lostLeads}> {lostLeadsLocalized}</div> {''}
          <span className={styles.subHeading}> contacts</span>
        </div>
        <PrimaryButton
          className={classNames(styles.button, css?.button)}
          onClick={onClick}
        >
          {buttonName}
        </PrimaryButton>
        <div className={styles.text}>No credit card required</div>
      </div>
      {withTooltip && (
        <div className={classNames(styles.tooltip, css?.tooltip)}>
          You ran this report {time} {timeLabel} ago and in that time we could
          have collected {lostLeadsLocalized} contacts
        </div>
      )}
    </div>
  );
};
